import { isOfType } from 'common/helpers'
import type { Nullable } from 'common/types'

export type SpaConfig = {
  gpnCounterId: Nullable<string>
  gpnCounterUrl: string
  gpnSpaUrl: string
}

type SpaCustomParamTypes = 'STRING' | 'INT' | 'FLOAT' | 'BOOLEAN' | 'DATE'
type SpaCustomParamNames =
  | 'user_id'
  | 'project_name'
  | 'database_name'
  | 'database_filters'
  | 'folder_name'
  | 'group_name'
  | 'as_user_id'
  | 'project_type'
  | 'object_type'
  | 'object_name'
  | 'count'

export type SpaEventId =
  | 'import_click'
  | 'new import_search'
  | 'new import_database selection'
  | 'new import_geobd_search'
  | 'new import_crms_search'
  | 'new import_folder selection'
  | 'new import_add all to projec'
  | 'new import_add file to project'
  | 'new import_file added'
  | 'project_open'
  | 'project_delete'
  | 'project_new_click'
  | 'project_new_create'
  | 'project_edit_click'
  | 'project_edit_update'
  | 'project_archive_done'
  | 'project_publication_done'
  | 'project_publication_click'
  | 'project_archive_click'
  | 'import from file_seismic'
  | 'import from file_well'
  | 'import from file_polygon'
  | 'import from file_maps'
  | 'import from file_end'
  | 'import from file_seismic_end'
  | 'import from file_loaded'
  | 'import from file_seismic_loaded'
  | 'import from PC_markers'
  | 'import from PC_3D'
  | 'hot storage_click'
  | 'hot storage_add well'
  | 'hot storage_add marker'
  | 'hot storage_add seismic'
  | 'hot storage_well load'
  | 'hot storage_marker load'
  | 'hot storage_seismic load'

export type SpaCustomParam = {
  value: string | number | boolean | Date
  name: SpaCustomParamNames
  type: SpaCustomParamTypes
}

export type DataToSendEvent = {
  id: SpaEventId
  params: SpaCustomParam[]
}

// TODO: добавить vsp
const GeoSpaTypeArr = ['map', 'polygon'] as const
export const isGeoSpaType = isOfType(GeoSpaTypeArr)

const SeismicSpaTypeArr = ['horizon', 'fault', 'survey2d'] as const
export const isSeismicSpaType = isOfType(SeismicSpaTypeArr)

export type DataAnalyticsId = {
  dataAnalyticsId?: SpaEventId
}
